import {
  buildAdditionalContactCard,
  type ContactCardOverrides,
} from './additionalContactCard';

export const appraiserContactCard = buildAdditionalContactCard({
  contactType: 'appraiser',
  contactLabel: 'Appraiser',
  overrides: {
    fields: {
      role: {
        label: 'Role',
        placeholderText: 'Appraiser, Assistant, etc',
      },
      firstName: {
        action: {
          props: (props) =>
            props.concat([
              {
                from: 'licenseNumber',
                to: 'contacts.appraiser.x.licenseNumber',
              },
            ]),
        },
      },
    },
  } satisfies ContactCardOverrides,
});
